export default function getResource(label, vars = []) {
    const resources = {
        appliesToAll: `Applies to ${vars[0]}, select all that apply:`,
        appliesToOne: `Applies to ${vars[0]}, select one:`,
        selectOne: 'Select one:',
        selectAll: 'Select all that apply:',
        saveAndContinue: 'Save And Continue',
        and: ' and ',
        skipThisQuestion: 'Skip this question',
        searchIngredients: 'Search ingredients',
        searchBrands: 'Search brands',
        viewIngredientList: 'View ingredient list',
        viewAllBrands: 'View all brands',
        skincareIngredientPreferences: 'Skincare Ingredient Preferences',
        hairIngredientPreferences: 'Hair Ingredient Preferences',
        makeupIngredientPreferences: 'Makeup Ingredient Preferences',
        fragranceIngredientPreferences: 'Fragrance Ingredient Preferences',
        favoriteBrands: 'Favorite Brands',
        noPreference: 'No preference',
        selectAllThatApply: 'Select all that apply',
        clear: 'Clear all',
        apply: 'Apply',
        noResults: 'No results.',
        clearSearch: 'Clear',
        useOur: 'Use our ',
        shadeFinder: 'Shade Finder',
        toDiscover: '  to discover more matches based on your current foundation, or head to a Sephora store and ask for a Color iQ skin tone scan.',
        colorIQModalTitle: 'Color IQ',
        colorIQModalDescription: 'Color IQ is a proprietary system that uses advanced technology to help you find your perfect shade match across all foundation products.',
        colorIQLink: 'Shop Matching Foundation Products',
        gotIt: 'Got It',
        viewAll: 'View All',
        colorIQHistoryTitle: 'Your Saved Color IQ Values',
        latest: 'CURRENT',
        captured: 'Captured',
        joinBeautyInsiderToSave: 'Join Beauty Insider to Save',
        signInToSave: 'Sign in to Save',
        save: 'Save'
    };
    return resources[label];
}
